/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonInputsComponent } from './person-inputs/person-inputs.component';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {InputTextModule} from "primeng/inputtext";
import {SharedComponentsModule} from "@irian-ro/shared-components-module";
import {ResourceDropdownModule} from "@well/resource-dropdown";
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { InputTrimDirective } from '@well/infra/directives';
import { FloatLabel } from 'primeng/floatlabel';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    InputTextModule,
    SharedComponentsModule,
    ResourceDropdownModule,
    FormInlineErrorDirective,
    InputTrimDirective,
    FloatLabel
  ],
  declarations: [PersonInputsComponent],
  exports: [PersonInputsComponent],
})
export class PersonManagementModule {}
